import PhoneInput from 'antd-phone-input';
import React, { useState } from 'react';
import './Whatsapp.css';

const Whatsapp = ({ handleSavePhoneNumber }) => {
    const [phone, setPhone] = useState('');

    return (
        <div className="Whatsapp">
            <div className="WhatsappContent">
                <h1>Configurações de WhatsApp</h1>
                <p>Insira o número do WhatsApp onde gostaria de receber os comprovantes analisados.</p>
                <div className="PhoneInputWrapper">
                    <PhoneInput
                        enableSearch
                        value={phone}
                        onChange={(value) => setPhone(value)}
                    />
                </div>
                <button
                    className="SaveButton"
                    type="button"
                    onClick={() => handleSavePhoneNumber(`${phone.areaCode}${phone.phoneNumber}`)}
                >
                    Salvar
                </button>
            </div>
        </div>
    );
};

export default Whatsapp;
